import {useMemo} from 'react';

import {config as staticConfig} from '@/config';
import {ConfigContext} from '@/modules/common/context/Config/ConfigContext';
import {type Config} from '@/modules/common/context/Config/models';
import {useConfigServiceConfig} from '@/modules/common/queries/configService';
import {usePageServiceSite} from '@/modules/common/queries/pageService';

type Props = React.PropsWithChildren;

export const ConfigProvider: React.FunctionComponent<Props> = ({children}) => {
  const configServiceQuery = useConfigServiceConfig();
  const pageServiceQuery = usePageServiceSite();

  const config = useMemo<Config>(() => {
    const configServiceConfig = configServiceQuery.data || null;
    const pageServiceConfig = pageServiceQuery.data || null;

    return {
      ...staticConfig,
      configService: configServiceConfig,
      pageService: pageServiceConfig,
    };
  }, [configServiceQuery.data, pageServiceQuery.data]);

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};
